import { API } from "../axios/API";

export const configuracionService = {
  async getConfiguracion(data) {
    const resp = await API.post("/configuracion", data);
    return resp?.data;
  },
};